"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _constants = require("../../utils/constants");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Renders the footer email subscribe form
 *
 * @param {object} props sitecore fields Properties used to render the email subscribe form
 *
 * @returns {React.ReactElement} email subscribe form element
 */
function EmailSubscribeForm(props) {
  if (!props.fields) return null;
  var [submitted, setSubmitted] = (0, _react.useState)(false);
  var [emailAddr, setEmailAddr] = (0, _react.useState)('');
  var [error, setErrorStatus] = (0, _react.useState)(false);
  var [submitMessage, setSubmitMessage] = (0, _react.useState)((0, _richTextField.parseHTML)(props.fields.SubmitProgressMessage));
  var [submitResult, setSubmitResult] = (0, _react.useState)('error');
  var ValidateEmail = e => {
    e.preventDefault();
    setErrorStatus(false);
    setEmailAddr('');
    if (!_constants.EMAIL_REG_EXP.test(e.target.value)) setErrorStatus(true);else setEmailAddr(e.target.value);
  };
  var submitSubscribeFn = e => {
    e.preventDefault();
    setErrorStatus(false);
    if ((0, _lodash.isEmpty)(emailAddr)) {
      setErrorStatus(true);
    } else {
      var utmParams = JSON.parse((0, _lodash.replace)(JSON.stringify((0, _utils.getCookieJson)(_constants.UTM_PARAMS_COOKIE, true)), 'gclid', 'advertisementId'));
      var subscribeType = props.fields.SusbscribeForm.fields;
      var data = {
        emailAddress: emailAddr,
        pageUrl: (0, _utils.getMMDomainUrl)(props.params.pagePath),
        formId: subscribeType.Value.value,
        formName: subscribeType.Key.value,
        utmParam: utmParams
      };
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      };
      setSubmitted(true);
      fetch('/apicalls/emailSubscribe', requestOptions).then(response => {
        if (response.status === 200) {
          setSubmitMessage((0, _richTextField.parseHTML)(props.fields.ThankYouMessage));
          setSubmitResult('success');
        } else {
          setSubmitMessage((0, _richTextField.parseHTML)(props.fields.SubmitErrorMessage));
        }
      }).catch(err => {
        setSubmitMessage((0, _richTextField.parseHTML)(props.fields.SubmitErrorMessage));
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    id: "email-subscribe-form"
  }, !submitted && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group ".concat(error ? 'is-invalid' : '')
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    name: "emailSubscribe",
    id: "emailSubscribe",
    maxLength: "255",
    className: "form-control",
    placeholder: props.fields.InputPlaceholderText.value,
    "aria-label": props.fields.InputPlaceholderText.value,
    required: true,
    onChange: e => ValidateEmail(e)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: 'link',
    onClick: e => submitSubscribeFn(e),
    label: props.fields.SubmitButtenText.value,
    type: 'submit'
  }))), error && /*#__PURE__*/_react.default.createElement("div", {
    className: "invalid-feedback"
  }, props.fields.InvalidEmailErrorMessage.value)), submitted && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body",
    "data-submit-status": submitResult
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "h4"
  }, submitMessage)));
}
;
var _default = exports.default = EmailSubscribeForm;